// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-warning
 * @tagname hzn-icon-warning
 * @summary An individual icon for Horizon
 */
export class HznIconWarning extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.0652 4.00003C10.835 2.6667 12.7595 2.6667 13.5293 4.00003L21.3235 17.5C22.0933 18.8334 21.131 20.5 19.5914 20.5H4.00298C2.46338 20.5 1.50113 18.8334 2.27093 17.5L10.0652 4.00003ZM11.7972 5.00003L4.00298 18.5H19.5914L11.7972 5.00003ZM12.7972 16C12.7972 16.5523 12.3495 17 11.7972 17C11.2449 17 10.7972 16.5523 10.7972 16C10.7972 15.4477 11.2449 15 11.7972 15C12.3495 15 12.7972 15.4477 12.7972 16ZM12.7972 9H10.7972V14H12.7972V9Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=warning.js.map